import { render, staticRenderFns } from "./CreateSellerOrder.vue?vue&type=template&id=1f20bf06&"
import script from "./CreateSellerOrder.vue?vue&type=script&lang=js&"
export * from "./CreateSellerOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateSellerOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports